import React from 'react'
import Seo from '../shared/seo'
import GameContent from '../components/organisms/game-content/game-content'
import { title, description } from '../constants/activity-seo'
import ModalViewer from '../components/organisms/modal-viewer/modal-viewer'
/* import PageLayout from '../components/templates/page-layout/page-layout' */

const Game = () => {
  //  return  <GameContent />;

  /* return (
    <PageLayout hiddenNav={true}>
      <GameContent />
    </PageLayout>
  ) */

  return (
    <div>
      <Seo title={title} description={description} />
      <ModalViewer />
      <GameContent />
    </div>
  )
}

export default Game
